var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer-box" },
    [
      !_vm.multiple
        ? _c(
            "el-select",
            _vm._b(
              {
                ref: "customer-select",
                attrs: {
                  placeholder: _vm.$attrs.placeholder || "请选择操作人",
                  filterable: true,
                  clearable: _vm.clearable,
                  "filter-method": _vm.filterCustomer
                },
                on: {
                  change: _vm.customerChange,
                  clear: _vm.clearCustomer,
                  "visible-change": _vm.onVisibleChange,
                  focus: _vm.selectFocus
                },
                model: {
                  value: _vm.form.customerId,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "customerId", $$v)
                  },
                  expression: "form.customerId"
                }
              },
              "el-select",
              _vm.$attrs,
              false
            ),
            _vm._l(_vm.users, function(item) {
              return _c("el-option", {
                key: item[_vm.defaultProps.value],
                attrs: {
                  label: _vm.getLabelText(item),
                  value: "" + item[_vm.defaultProps.value],
                  disabled: _vm.isDisabled(item)
                }
              })
            }),
            1
          )
        : _c("ybl-multi-select", {
            staticClass: "el-select__small",
            attrs: {
              selectedAll: _vm.selectedAll,
              selectText: _vm.selectText,
              items: _vm.originUsers,
              props: _vm.defaultProps,
              placeholder: _vm.$attrs.placeholder || "请选择操作人",
              "label-select": true,
              filterable: true,
              clearable: !_vm.readonly,
              readonly: _vm.readonly,
              disableList: _vm.disableList
            },
            on: { change: _vm.customerChange },
            model: {
              value: _vm.form.customerId,
              callback: function($$v) {
                _vm.$set(_vm.form, "customerId", $$v)
              },
              expression: "form.customerId"
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d7a810e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d7a810e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer.vue
// module id = null
// module chunks = 